module.exports = __webpack_public_path__ + "img/full2-min.6fd31554.png";